import { Location } from "../../../types/location/location";
import { LocationDto } from "../../../types/location/location-dto";
import { convertLocationDtoToLocation } from "../../../utils/converter/location/location-converter";
import { LocationState } from "../../type/location-state";

interface Action {
  type: string;
  payload: {
    locationDto: LocationDto;
  };
}

export const setLocationPageByDtoDispatch = (
  state: LocationState,
  action: Action
) => {
  const { locationDto } = action.payload;
  const newLocation = convertLocationDtoToLocation(locationDto);

  const index = state.locationPage.contents.findIndex((location: Location) => {
    return location.id === newLocation.id;
  });

  if (index !== -1) {
    state.locationPage.contents[index] = newLocation;
  } else {
    state.locationPage = {
      ...state.locationPage,
      contents: [newLocation, ...state.locationPage.contents.slice(0, 9)],
    };
  }
};
